var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.model.status_dot)}}),_vm._v(" "),_c('span',{staticClass:"ml-md"},[_vm._v("\n        "+_vm._s(_vm.model.status_label)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }